import { render } from "./side-menu-special.vue?vue&type=template&id=dcca5fe8"
import script from "./side-menu-special.vue?vue&type=script&lang=js"
export * from "./side-menu-special.vue?vue&type=script&lang=js"

import "./side-menu-special.vue?vue&type=style&index=0&id=dcca5fe8&lang=scss"

import exportComponent from "/usr/src/oho-config-test/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__